<div class="popup-header"> {{productForm.value.name}}</div>
<form *ngIf="productForm" [formGroup]="productForm" (ngSubmit)="onSubmit()">
  <div mat-dialog-content>

    <mat-tab-group>
      <mat-tab label="Detail">
        <div class="contianer-fluid">

          <input type="hidden" id="id" class="form-control" formControlName="id">
          <div class="col-xs-12">
            <div class="form-group">
              <label for="name">
                Name
              </label>
              <input type="text" id="name" class="form-control" formControlName="name" >
            </div>
          </div>
          <div class="col-xs-12">
            <input type="file" (change)="onImageChange($event)" accept="image/*">

            <img *ngIf="productForm.value.imageUrl && !base64textString" [src]="productForm.value.imageUrl" alt=""
              class="img-responsive rounded-right rounded-left" style="max-height:100px ">

            <img *ngIf="base64textString" [src]="base64textString" alt="" class="img-responsive"
              style="max-height: 200px;">

          </div>




          <div class="form-row">
            <div class="form-group col-md-3">
              <label for="maxLimit">
                Maximum products
              </label>
              <input type="text" id="maxLimit" class="form-control" formControlName="maxLimit">
            </div>
            <div class="form-group col-md-3">
              <label for="threshold">
                Alarm threshold
              </label>
              <input type="text" id="threshold" class="form-control" formControlName="threshold">
            </div>
            <div class="form-group col-md-3">
              <label for="shelfLifeDays">
                Shelf life (days)
              </label>
              <input type="number" id="shelfLifeDays" class="form-control" formControlName="shelfLifeDays"
                     placeholder="category default"
                     title="Days this product keeps in a machine. Empty = use the category's shelf life. Drives the driver app's suggested svinn.">
            </div>
            <div class="form-group col-md-3">
              <label for="name">
                Part number
              </label>
              <input type="text" id="name" class="form-control" formControlName="productNumber">
            </div>
            <div class="form-group col-md-3">
              <label for="ILProductName">
                IL Product Name
              </label>
              <input type="text" id="ILProductName" class="form-control" formControlName="ILProductName">
            </div>
          </div>
          <!-- <div class="form-row">
            <div class="form-group col-md-6">

              <label for="extractionTime">Extraction Time</label>
              <input type="number" min="0" max="10" id="extractionTime" class="form-control" formControlName="extractionTime">
            </div>
            <div class="form-group col-md-6">
              <label for="voltage">Voltage</label>
              <input type="number"   min="0" max="10" id="voltage" class="form-control" placeholder="0" formControlName="voltage">
            </div>
          </div> -->

          <div class="form-row">
            <div class="form-group col-md-3">

              <label for="price">Price (inc VAT%)</label>
              <input type="number" id="price" class="form-control" formControlName="price">
            </div>
            <div class="form-group col-md-3">
              <label for="barcode">VAT %</label>
              <input type="number" id="vat" class="form-control" placeholder="15" formControlName="vat">
            </div>
            <div class="form-group col-md-3">
              <label for="pant">Pant (ex VAT%) </label>
              <input type="number" id="pant" class="form-control" placeholder="15" formControlName="pant">
            </div>
            <div class="form-group col-md-3">
              <label for="cost">Product Cost</label>
              <input type="number" id="cost" class="form-control" placeholder="15" formControlName="cost">
            </div>
            <div class="form-group col-md-3">
              <label for="minCateringOrder">Min. meeting food order qty</label>
              <input type="number" id="minCateringOrder" class="form-control" min="1" placeholder="3" formControlName="minCateringOrder">
            </div>
          </div>

          <!-- <div class=" form-group form-row">
          
          </div> -->
          <section class="example-section">
            <mat-checkbox formControlName="isHalal">Halal</mat-checkbox>
            <mat-checkbox formControlName="isVegetar">Vegetar</mat-checkbox>
            <mat-checkbox formControlName="isNew">New</mat-checkbox>
            <mat-checkbox formControlName="isGlutenFri">Gluten Fri</mat-checkbox>
            <mat-checkbox formControlName="isLaktoseFri">Laktose Fri</mat-checkbox>
            <mat-checkbox formControlName="dagensProdukt">Dagens Produkt</mat-checkbox>
            <mat-checkbox formControlName="isNewRecipe">New Recipe</mat-checkbox>
          </section>

          <div class="col-xs-12">
            <div class="form-group">
              <label for="category">Select category from list</label>
              <mat-form-field appearance="fill" style="width:100%">
                <mat-select formControlName="category" placeholder="Select category">
                  <mat-option value="" disabled selected *ngIf="productForm.get('category').value === ''">No category set</mat-option>
                  <mat-option *ngFor="let category of allCategories" [value]="category">
                    {{category}}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="missingCategoryWarning" style="color: #d32f2f;">This product has no category set. Please select one.</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <div class="col-xs-12">
            <div class="form-group">
              <label for="description"> Description</label>
              <textarea type="text" id="description" class="form-control" row="6" formControlName="description">

                        </textarea>
            </div>
          </div>

          <div class="col-xs-12">
            <div class="form-group">
              <label for="allergens">Allergens</label>
              <textarea type="text" id="allergens" class="form-control" rows="3" formControlName="allergens"
                placeholder="e.g. Gluten, Milk, Egg"></textarea>
            </div>
          </div>

          <div class="col-xs-12">
            <h4>Nutrition information (per 100 g/ml)</h4>
          </div>
          <div class="form-row">
            <div class="form-group col-md-3">
              <label for="nutritionEnergyKj">Energy (kJ)</label>
              <input type="number" id="nutritionEnergyKj" class="form-control" formControlName="nutritionEnergyKj">
            </div>
            <div class="form-group col-md-3">
              <label for="nutritionEnergyKcal">Energy (kcal)</label>
              <input type="number" id="nutritionEnergyKcal" class="form-control" formControlName="nutritionEnergyKcal">
            </div>
            <div class="form-group col-md-3">
              <label for="nutritionFat">Fat (g)</label>
              <input type="number" id="nutritionFat" class="form-control" formControlName="nutritionFat">
            </div>
            <div class="form-group col-md-3">
              <label for="nutritionSaturatedFat">of which saturates (g)</label>
              <input type="number" id="nutritionSaturatedFat" class="form-control" formControlName="nutritionSaturatedFat">
            </div>
            <div class="form-group col-md-3">
              <label for="nutritionCarbs">Carbohydrates (g)</label>
              <input type="number" id="nutritionCarbs" class="form-control" formControlName="nutritionCarbs">
            </div>
            <div class="form-group col-md-3">
              <label for="nutritionSugar">of which sugars (g)</label>
              <input type="number" id="nutritionSugar" class="form-control" formControlName="nutritionSugar">
            </div>
            <div class="form-group col-md-3">
              <label for="nutritionProtein">Protein (g)</label>
              <input type="number" id="nutritionProtein" class="form-control" formControlName="nutritionProtein">
            </div>
            <div class="form-group col-md-3">
              <label for="nutritionSalt">Salt (g)</label>
              <input type="number" id="nutritionSalt" class="form-control" formControlName="nutritionSalt">
            </div>
          </div>

        </div>
      </mat-tab>
      <mat-tab label="References">
        <!-- <p> -->
        <mat-card appearance="outlined" *ngFor="let item of productChannelRef$ |async; let i = index"> <a [routerLink]="linkMaker(item)"
            target="_blank">Reference - {{ i+1}} {{item.systemName}}</a>
          <mat-card-actions align="end">
            <button mat-button type="button" (click)="removeRefrence(item)">Force remove</button>
          </mat-card-actions>
        </mat-card>
        <!-- <span (click)="removeRefrence(item)">x</span>  -->
        <!-- </p> -->
      </mat-tab>
    </mat-tab-group>

  </div>
  <div mat-dialog-actions align="end">
    <mat-checkbox formControlName="isDisabled" style="margin-right:auto;">
      Product disabled
    </mat-checkbox>
    <button type="button" mat-raised-button (click)="onNoClick()">Cancel</button>
    <button type="submit" class="theme-button" mat-raised-button [disabled]="!productForm.valid">
      Save
    </button>
  </div>
</form>